/* One Bioactive Canopy theme – vanilla JS, no dependencies */
(() => {
  'use strict';
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));
  const T = window.theme || { routes: {}, strings: {} };

  const money = (cents) => {
    const fmt = T.moneyFormat || '${{amount}}';
    const v = (cents / 100).toFixed(2);
    const withCommas = v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withCommas)
      .replace(/<[^>]+>/g, '');
  };

  /* Header offset for mobile menu --------------------------------------- */
  const header = $('[data-header]');
  const setHeaderVar = () => {
    if (!header) return;
    document.documentElement.style.setProperty('--header-bottom', header.getBoundingClientRect().bottom + 'px');
  };
  setHeaderVar();
  window.addEventListener('resize', setHeaderVar, { passive: true });
  window.addEventListener('scroll', setHeaderVar, { passive: true });

  const mnav = $('[data-mnav]');
  if (mnav) mnav.addEventListener('toggle', () => {
    setHeaderVar();
    document.body.style.overflow = mnav.open ? 'hidden' : '';
  });

  /* Search overlay + predictive search ---------------------------------- */
  const search = $('[data-search]');
  const searchInput = $('[data-predictive-input]');
  const results = $('[data-predictive-results]');
  const openSearch = () => { if (!search) return; search.hidden = false; searchInput && searchInput.focus(); };
  const closeSearch = () => { if (search) search.hidden = true; };
  $$('[data-search-open]').forEach((b) => b.addEventListener('click', () => (search.hidden ? openSearch() : closeSearch())));
  $$('[data-search-close]').forEach((b) => b.addEventListener('click', closeSearch));
  let searchTimer;
  if (searchInput && results) {
    searchInput.addEventListener('input', () => {
      clearTimeout(searchTimer);
      const q = searchInput.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      searchTimer = setTimeout(async () => {
        try {
          const url = `${T.routes.predictiveSearch}?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[type]=product,collection,page,article&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,tag`;
          const html = await (await fetch(url)).text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const section = doc.querySelector('.shopify-section') || doc.body;
          results.innerHTML = section.innerHTML;
        } catch (e) { /* network error – leave results */ }
      }, 220);
    });
  }

  /* Cart drawer ---------------------------------------------------------- */
  const drawer = $('[data-cart-drawer]');
  let lastFocus;
  const openDrawer = () => {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.body.style.overflow = 'hidden';
    const close = $('[data-drawer-close].icon-btn', drawer);
    close && close.focus();
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.hidden = true;
    document.body.style.overflow = '';
    lastFocus && lastFocus.focus();
  };
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-open]') && drawer) { e.preventDefault(); openDrawer(); }
    if (e.target.closest('[data-drawer-close]')) closeDrawer();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (drawer && !drawer.hidden) closeDrawer();
    if (search && !search.hidden) closeSearch();
    const facets = $('[data-facets].is-open');
    facets && facets.classList.remove('is-open');
  });

  const renderSections = (sections) => {
    if (!sections) return;
    if (sections['cart-drawer'] && drawer) {
      const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      const panel = doc.querySelector('.drawer__panel');
      if (panel) $('.drawer__panel', drawer).innerHTML = panel.innerHTML;
    }
  };
  const updateCount = (count) => {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
  };

  const addToCart = async (items) => {
    const res = await fetch(`${T.routes.cartAdd}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: 'cart-drawer', sections_url: window.location.pathname })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Error');
    renderSections(data.sections);
    const cart = await (await fetch(`${T.routes.cart}.js`)).json();
    updateCount(cart.item_count);
    openDrawer();
    return data;
  };
  window.OBAddToCart = addToCart;

  const changeLine = async (line, quantity) => {
    const res = await fetch(`${T.routes.cartChange}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
    });
    const cart = await res.json();
    renderSections(cart.sections);
    updateCount(cart.item_count);
  };
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    changeLine(Number(btn.dataset.qtyChange), Math.max(0, Number(btn.dataset.qty)));
  });

  // Quick add from product cards
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-quick-add]');
    if (!form) return;
    e.preventDefault();
    const btn = $('button', form);
    btn.disabled = true;
    try { await addToCart([{ id: Number(form.id.value), quantity: 1 }]); } catch (err) { window.location = T.routes.cart; }
    btn.disabled = false;
  });

  /* Product page --------------------------------------------------------- */
  $$('[data-product]').forEach((root) => {
    const form = $('.js-product-form', root);
    const variants = JSON.parse(($('[data-product-json]', root) || {}).textContent || '[]');
    const idInput = $('[data-variant-id]', root);
    const addBtn = $('[data-add-btn]', root);
    const priceWrap = $('[data-price-wrap] [data-price]', root);
    const errorEl = $('[data-form-error]', root);
    const main = $('[data-gallery-main]', root);
    const dots = $$('.gallery__dots span', root);
    const thumbs = $$('[data-thumb]', root);
    const sticky = $('[data-sticky-atc]', root);
    const stickyPrice = $('[data-sticky-price]', root);
    const stickyAdd = $('[data-sticky-add]', root);
    let current = variants.find((v) => String(v.id) === idInput?.value) || variants[0];

    const goToMedia = (mediaId) => {
      const slide = $(`[data-media-id="${mediaId}"]`, root);
      if (slide && main) main.scrollTo({ left: slide.offsetLeft - main.offsetLeft, behavior: 'smooth' });
    };
    thumbs.forEach((t) => t.addEventListener('click', () => goToMedia(t.dataset.thumb)));
    if (main) {
      main.addEventListener('scroll', () => {
        const i = Math.round(main.scrollLeft / main.clientWidth);
        dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
        thumbs.forEach((t, n) => t.setAttribute('aria-current', n === i ? 'true' : 'false'));
      }, { passive: true });
    }

    const updateVariant = () => {
      if (!form) return;
      const selected = $$('.opt', form).map((fs) => ($('input:checked', fs) || {}).value);
      $$('.opt', form).forEach((fs, i) => { const out = $('[data-option-value]', fs); if (out) out.textContent = selected[i]; });
      current = variants.find((v) => v.options.every((o, i) => o === selected[i]));
      if (!current) {
        addBtn.disabled = true; addBtn.textContent = T.strings.unavailable;
        return;
      }
      idInput.value = current.id;
      addBtn.disabled = !current.available;
      addBtn.textContent = current.available ? T.strings.addToCart : T.strings.soldOut;
      if (stickyAdd) stickyAdd.disabled = !current.available;
      if (priceWrap) {
        const cur = $('.price__current', priceWrap);
        cur && (cur.textContent = money(current.price));
        const cmp = $('.price__compare', priceWrap);
        if (cmp) cmp.hidden = !(current.compare_at_price > current.price);
      }
      if (stickyPrice) stickyPrice.textContent = money(current.price);
      if (current.featured_media) goToMedia(current.featured_media.id);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', current.id);
      window.history.replaceState({}, '', url.toString());
    };
    form && form.addEventListener('change', (e) => { if (e.target.name && e.target.name.startsWith('options')) updateVariant(); });

    $$('[data-qty-step]', root).forEach((b) => b.addEventListener('click', () => {
      const input = $('input[name="quantity"]', root);
      input.value = Math.max(1, (Number(input.value) || 1) + Number(b.dataset.qtyStep));
    }));

    const submit = async () => {
      if (!current) return;
      errorEl && (errorEl.hidden = true);
      const label = addBtn.textContent;
      addBtn.disabled = true; addBtn.textContent = T.strings.adding;
      try {
        await addToCart([{ id: current.id, quantity: Number($('input[name="quantity"]', root).value) || 1 }]);
      } catch (err) {
        if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
      }
      addBtn.disabled = !current.available; addBtn.textContent = label;
    };
    form && form.addEventListener('submit', (e) => { e.preventDefault(); submit(); });
    stickyAdd && stickyAdd.addEventListener('click', submit);

    if (sticky && addBtn && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(([entry]) => {
        sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      }).observe(addBtn);
    }
  });

  /* Product recommendations --------------------------------------------- */
  $$('[data-recommendations]').forEach((el) => {
    if (el.children.length) return;
    const load = async () => {
      try {
        const html = await (await fetch(el.dataset.url)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      } catch (e) { /* ignore */ }
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => { if (entries[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '400px' });
      io.observe(el);
    } else load();
  });

  /* Collection filters --------------------------------------------------- */
  const facets = $('[data-facets]');
  if (facets) {
    const desktop = window.matchMedia('(min-width: 990px)');
    $$('[data-facets-open]', facets).forEach((b) => b.addEventListener('click', () => facets.classList.add('is-open')));
    $$('[data-facets-close]', facets).forEach((b) => b.addEventListener('click', () => facets.classList.remove('is-open')));
    const submitFacets = () => {
      const params = new URLSearchParams(new FormData(facets));
      for (const [k, v] of Array.from(params.entries())) if (v === '') params.delete(k);
      window.location.search = params.toString();
    };
    facets.addEventListener('change', (e) => {
      if (e.target.matches('[data-facets-sort]') || desktop.matches) submitFacets();
    });
    facets.addEventListener('submit', (e) => { e.preventDefault(); submitFacets(); });
  }

  /* Substrate calculator ------------------------------------------------- */
  $$('[data-calculator]').forEach((root) => {
    const section = root.closest('section');
    const data = JSON.parse(($('[data-calc-data]', section) || {}).textContent || '{}');
    const S = data.strings || {};
    const lIn = $('[data-calc-l]', root);
    const wIn = $('[data-calc-w]', root);
    const preset = $('[data-calc-preset]', root);
    const list = $('[data-calc-layers]', root);
    const totalEl = $('[data-calc-total]', root);
    const addBtn = $('[data-calc-add]', root);
    let bundle = [];

    const litresOf = (title) => {
      const m = String(title).match(/(\d+(?:\.\d+)?)\s*(l|litre|liter)/i);
      return m ? parseFloat(m[1]) : null;
    };
    // Pick the cheapest combination of a single size (smallest that covers need, else multiples of the largest)
    const pick = (product, need) => {
      if (!product) return null;
      const sized = product.variants.filter((v) => v.available && litresOf(v.title));
      if (!sized.length) {
        const v = product.variants.find((x) => x.available);
        return v ? [{ variant: v, qty: 1 }] : null;
      }
      sized.sort((a, b) => litresOf(a.title) - litresOf(b.title));
      const fit = sized.find((v) => litresOf(v.title) >= need);
      if (fit) return [{ variant: fit, qty: 1 }];
      const big = sized[sized.length - 1];
      const bigL = litresOf(big.title);
      const n = Math.floor(need / bigL);
      const top = sized.find((v) => litresOf(v.title) >= need - n * bigL);
      const combo = top && top.id !== big.id ? n * big.price + top.price : Infinity;
      return combo < Math.ceil(need / bigL) * big.price
        ? [{ variant: big, qty: n }, { variant: top, qty: 1 }]
        : [{ variant: big, qty: Math.ceil(need / bigL) }];
    };

    const render = () => {
      const unit = ($('input[name="unit"]:checked', root) || {}).value || 'cm';
      const habitat = ($('input[name="habitat"]:checked', root) || {}).value || 'tropical';
      const k = unit === 'in' ? 2.54 : 1;
      const L = (parseFloat(lIn.value) || 0) * k;
      const W = (parseFloat(wIn.value) || 0) * k;
      const area = L * W; // cm²
      const depths = (data.depths || {})[habitat] || { drainage: 0, soil: 10 };
      const layers = [];
      if (depths.drainage > 0) layers.push({ key: 'drainage', name: S.drainage, need: (area * depths.drainage) / 1000 });
      layers.push({ key: habitat, name: S.soil, need: ((area * depths.soil) / 1000) * 1.1 });
      layers.push({ key: 'litter', name: S.litter, need: null, qty: Math.max(1, Math.ceil(area / 2000)) });
      if (habitat === 'tropical') layers.push({ key: 'moss', name: S.moss, need: null, qty: 1 });

      bundle = [];
      let total = 0;
      list.innerHTML = layers.map((layer) => {
        const product = (data.layers || {})[layer.key];
        let picks = null;
        if (product) {
          if (layer.need != null) picks = pick(product, layer.need);
          else {
            const v = product.variants.find((x) => x.available);
            picks = v ? [{ variant: v, qty: layer.qty }] : null;
          }
        }
        let sub = 0;
        (picks || []).forEach((c) => { bundle.push({ id: c.variant.id, quantity: c.qty }); sub += c.variant.price * c.qty; });
        total += sub;
        const needTxt = layer.need != null ? `${Math.ceil(layer.need)} ${S.litres}` : '';
        const variantTxt = (picks || []).map((c) => `${c.qty} × ${c.variant.title === 'Default Title' ? '' : c.variant.title}`.trim()).join(' + ');
        return `<li class="layer">
          ${product && product.image ? `<img class="layer__img" src="${product.image}" alt="" width="52" height="52" loading="lazy">` : '<span class="layer__img"></span>'}
          <div><div class="layer__name">${layer.name}${needTxt ? ' · ' + needTxt : ''}</div>
          <div class="layer__prod">${product ? `<a href="${product.url}">${product.title}</a>` : '—'}</div>
          <div class="layer__meta">${variantTxt}</div></div>
          <div class="layer__price">${picks ? money(sub) : ''}</div>
        </li>`;
      }).join('');
      totalEl.textContent = bundle.length ? money(total) : '—';
      addBtn.disabled = !bundle.length;
    };

    preset && preset.addEventListener('change', () => {
      if (!preset.value) return;
      const [l, w] = preset.value.split('x');
      const cm = $('input[name="unit"][value="cm"]', root);
      cm.checked = true;
      lIn.value = l; wIn.value = w;
      render();
    });
    root.addEventListener('input', (e) => {
      if (e.target === lIn || e.target === wIn) preset.value = '';
      render();
    });
    root.addEventListener('change', render);
    addBtn.addEventListener('click', async () => {
      if (!bundle.length) return;
      addBtn.disabled = true;
      const label = addBtn.textContent;
      try { await addToCart(bundle); addBtn.textContent = S.added; } catch (e) { addBtn.textContent = label; }
      setTimeout(() => { addBtn.textContent = label; addBtn.disabled = false; }, 2000);
    });
    render();
  });
})();
